// CORE
import core from './scripts/login/core/core';
import configCommon from './scripts/common/config';
import config from './scripts/login/core/config';
import _ls from './scripts/common/localstorage';
import smartlock from './scripts/common/smartlock';
import customDimension from './scripts/common/customDimension';
import message from './scripts/login/core/message';
import helper from './scripts/login/core/helper';
import model from './scripts/login/core/model';
import handler from './scripts/login/core/handler';
import analytics from './scripts/login/core/analytics';

import service from './scripts/login/core/service';
import hotjar from './scripts/login/core/hotjar';   
import wcentrix from './scripts/common/wcentrix';
import logger from './scripts/login/core/logger';   
import userTracker from './scripts/common/user-tracker';
import password from './scripts/login/core/validar-clave-lib';

// CONTROLLERS
import credencialController from './scripts/login/controllers/credencial';
import facebookController from './scripts/login/controllers/facebook';
import gmailController from './scripts/login/controllers/gmail';
import redesController from './scripts/login/controllers/redes';
import nativoController from './scripts/login/controllers/nativo';
import registroController from './scripts/login/controllers/registro';


//APP
import app from "./scripts/login/app";


// EXT
import jquerynicSelect from './scripts/ext/jquery.nice-select';
import jqueryautoTab from './scripts/ext/jquery.autotab';




// Styles
import './styles/formularios.css';
import './styles/reset.css';
import './styles/login.css';
import './styles/images.css';




// WEBPACK FOOTER //
// ./Statics/login.js